import React from 'react';
import PropTypes from 'prop-types';
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';
import PendingImportCard from '../../PendingImportCard';

export default function PerformancePendingImportDialog({
    open,
    applying,
    error,
    run,
    onClose,
    onApply,
    onIgnore,
    title = 'Import Review',
}) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent dividers>
                {error && (
                    <Alert severity="error" sx={{ mb: 1.5 }}>
                        {error}
                    </Alert>
                )}
                {run ? (
                    <PendingImportCard
                        importRun={run}
                        onApply={
                            run.status === 'pending_apply'
                                ? onApply
                                : undefined
                        }
                        onIgnore={
                            run.status === 'pending_apply'
                                && run.source !== 'watchlist_sync'
                                ? onIgnore
                                : undefined
                        }
                        applying={applying}
                        showActions={run.status === 'pending_apply'}
                    />
                ) : (
                    <Typography variant="body2">Import not available.</Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    disabled={applying}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

PerformancePendingImportDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string,
    applying: PropTypes.bool,
    error: PropTypes.string,
    run: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onApply: PropTypes.func,
    onIgnore: PropTypes.func,
};
